import { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { LoadingToRedirect } from "@components";
import { useDispatch } from "react-redux";
import { isUserAction } from "@redux/actions/authActions";

const OnboardingRoute = ({ children, ...restProps }) => {
  const dispatch = useDispatch();
  const [ok, setOk] = useState(false);

  // Check if current user is admin
  useEffect(() => {
    dispatch(isUserAction({ setOk }));
  }, []);

  return (
    <>
      {ok ? <Route {...restProps} render={children} /> : <LoadingToRedirect />}
    </>
  );
};

export default OnboardingRoute;
